<template>
    <div class="table-responsive">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <h5 class="mb-0">{{title}}</h5>
        </div>
        <table class="table quiet-table">
        <thead>
            <tr>
            <th scope="col">#</th>
            <!-- <th scope="col">Type</th> -->
            <th scope="col">Amount</th>
            <th scope="col">Date</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(_row, index) in row" :key="index">
                <th scope="row">{{index+1}}</th>
                <!-- <td>{{ _row.type }}</td> -->
                <td>{{ this.$helper.formatPrice(_row.amount) }}</td>
                <td>{{ this.$helper.formatDate(_row.created_at, true) }}</td>
                <!-- <td>{{ _row.created_at }}</td> -->
            </tr>
        </tbody>
        </table>
    </div>
</template>
    
<script>

//import { fetchWrapper } from '@/helpers';

export default {
    name: 'investment-plan-summary-investment-type',
    components: {},
    props: {
        row: {type: Array},
        title: {type: String},
    },
    data() {
    return {}
    },
    methods: {
    
    },
    mounted() {

    }
}
</script>

<style scoped>
.quiet-table thead th {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
}

.quiet-table tbody th,
.quiet-table tbody td {
  border-bottom: 1px solid #f1f2f4;
}

.quiet-table tbody tr:last-child th,
.quiet-table tbody tr:last-child td {
  border-bottom: none;
}
</style>